import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './col.vdt';
import { PrimitiveValue, Value, breakpoints } from './constants';
import { useBreakpoints } from './useBreakpoints';
import { useConfigContext } from '../config';
export var baseTypeDefs = {
  span: PrimitiveValue,
  offset: PrimitiveValue,
  order: PrimitiveValue,
  pull: PrimitiveValue,
  push: PrimitiveValue
};
var typeDefs = _extends({}, baseTypeDefs, breakpoints.reduce(function (memo, key) {
  memo[key] = Value;
  return memo;
}, {}));
export var Col = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Col, _Component);
  function Col() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.breakpoints = useBreakpoints();
    _this.config = useConfigContext();
    return _this;
  }
  return Col;
}(Component);
Col.template = template;
Col.typeDefs = typeDefs;